import axios from 'axios';

const getSingleBlogApi = async (paramsFilter, langIsoCode) => {
  try {
    const url = `/Blog/single?blog_id=${paramsFilter?.blogId || ''}`;
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        lang: langIsoCode
      }
    });

    return res;
  } catch (error) {
    throw error;
  }
};

export default getSingleBlogApi;
